<div class="btn-toolbar">
    <div class="btn-group">
        <div title="{{'msg#statusbar.networkActivity' | sqMessage}}">
            <span class="fas fa-bolt" [ngClass]="{'blink': active}"></span>
        </div>
    </div>
</div>
